import { render } from "./ActivateAi.vue?vue&type=template&id=3bfed5f8&scoped=true&ts=true"
import script from "./ActivateAi.vue?vue&type=script&lang=ts"
export * from "./ActivateAi.vue?vue&type=script&lang=ts"

import "./ActivateAi.vue?vue&type=style&index=0&id=3bfed5f8&lang=scss&scoped=true"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfed5f8"]])

export default __exports__